import { supabase } from './supabase';

export const getPublicFileUrl = (storagePath: string): string => {
  const { data } = supabase.storage
    .from('public-files')
    .getPublicUrl(storagePath);

  return data.publicUrl;
};

export const getPrivateFileUrl = async (storagePath: string): Promise<string> => {
  const { data, error } = await supabase.storage
    .from('private-files')
    .createSignedUrl(storagePath, 3600);

  if (error) throw error;
  return data.signedUrl;
};

export const uploadToPublicBucket = async (
  path: string,
  file: File
): Promise<{ path: string; error: Error | null }> => {
  const { data, error } = await supabase.storage
    .from('public-files')
    .upload(path, file, {
      cacheControl: '3600',
      upsert: false
    });

  return { path: data?.path || '', error };
};

export const uploadToPrivateBucket = async (
  path: string,
  file: File
): Promise<{ path: string; error: Error | null }> => {
  const { data, error } = await supabase.storage
    .from('private-files')
    .upload(path, file, {
      cacheControl: '3600',
      upsert: false
    });

  return { path: data?.path || '', error };
};

export const deleteFromPublicBucket = async (
  path: string
): Promise<{ error: Error | null }> => {
  const { error } = await supabase.storage
    .from('public-files')
    .remove([path]);

  return { error };
};

export const deleteFromPrivateBucket = async (
  path: string
): Promise<{ error: Error | null }> => {
  const { error } = await supabase.storage
    .from('private-files')
    .remove([path]);

  return { error };
};
